import { Injectable } from '@angular/core';

import {HttpOptionsModel} from '@myModels/Shared/http-options';
import {CustomHttpService} from '@myServices/custom-http.service';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class GroupService {

  public currentGroupGames;

  constructor(private customHttpService: CustomHttpService) { }

  getGroups() {
    let httpOptions = new HttpOptionsModel('/game/groups', null, false, true);
    return this.customHttpService.post(httpOptions).pipe(
        catchError((error) => {
            if (error.error.messages) {
                throw new Error(error.error.messages[0]);
            }
            throw new Error('UNEXPECTED_ERROR');
        }), map((res: any) => {
            if (!res.status) {
                throw new Error(res.messages[0]);
            }
            return res;
        })
    );
  }
  getGamesByGroupId(groupId){
    let postData = {
      group:groupId
    }
    let httpOptions = new HttpOptionsModel('/group-games', postData, false, true);
    return this.customHttpService.post(httpOptions).pipe(
        catchError((error) => {
            if (error.error.messages) {
                throw new Error(error.error.messages[0]);
            }
            throw new Error('UNEXPECTED_ERROR');
        }), map((res: any) => {
            if (!res.status) {
                throw new Error(res.messages[0]);
            }
            return res;
        })
    );
  }


  getGamesByType(typeID){
    let postData = {
      type:typeID
    }
    let httpOptions = new HttpOptionsModel('/game/groups/filter-type', postData, false, true);
    return this.customHttpService.post(httpOptions).pipe(
        catchError((error) => {
            if (error.error.messages) {
                throw new Error(error.error.messages[0]);
            }
            throw new Error('UNEXPECTED_ERROR');
        }), map((res: any) => {
            if (!res.status) {
                throw new Error(res.messages[0]);
            }
            return res;
        })
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/group.service.ts